import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { TerminatedByType, TerminationReasonType } from '@/domain/contract/types/messages'

type TerminationByProps = {
  reason: TerminationReasonType
  terminatedBy: string
  terminatedByType: TerminatedByType
}

export const TerminatedBy: FC<TerminationByProps> = ({ terminatedBy, terminatedByType, reason }) => {
  const { t } = useTranslation()

  if (reason === TerminationReasonType.INITIAL_MIGRATION) {
    return t('contract.messagesFlyout.notRecorded')
  }

  switch (terminatedByType) {
    case TerminatedByType.CUSTOMER:
      return t('contract.messagesFlyout.fields.terminatedByCustomer', { terminatedBy })
    case TerminatedByType.ENBW:
      return t('contract.messagesFlyout.fields.terminatedByEnbw', { terminatedBy })
  }
}
